module.exports = __webpack_public_path__ + "static/img/Washroom-Branding.a53ed5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertisingImagesNew/Washroom-Branding.jpg
// module id = uGVG
// module chunks = 12